import { HandleableError } from "@shared/utils/errors/handleableError";

export const catchError = <T, E extends new (message: string) => Error>(
  promise: Promise<T>
): Promise<[undefined, T] | [InstanceType<E> | HandleableError, null]> =>
  promise
    .then((data) => {
      // Логируем успешные ответы
      // Проверяем, является ли data ответом axios
      if (data && typeof data === 'object' && 'data' in data && 'status' in data && 'config' in data) {
        const response = data as any;
        const request = response.config || {};
        console.log(`[API Response Success] ${response.status}:`, {
          url: request.url || request.baseURL,
          method: request.method?.toUpperCase(),
          status: response.status,
          statusText: response.statusText,
          data: response.data,
          dataString: response.data ? JSON.stringify(response.data, null, 2).substring(0, 500) : undefined,
        });
      }
      return [undefined, data] as [undefined, T];
    })
    .catch((error) => {
      if (error instanceof HandleableError) {
        error.handle();
        return [error, null];
      }
      throw error;
    });

